/* eslint-disable prefer-destructuring, @typescript-eslint/naming-convention, no-undef */
// @ts-ignore
__webpack_public_path__ = window.__webpack_public_path__;

// eslint-disable-next-line import/no-default-export
export default window.__webpack_public_path__;
